<template>
  <div class="logout">
    
  </div>
</template>

<script>
import api from '../services/service.js'

export default {
  name: 'logout',
  data () {
    return {
    }
  },
  async mounted() {
    // this.$emit('logout');
    // console.log("test")
    this.$parent._data.nominativo = '';
    this.$parent._data.codFisc = ''
    api.execute('post', 'oauth/logout', undefined, true)
    // api.execute('post', 'privacy/consent', {ip: "x", agreed: "asdasdas"})
    // location.href = "https://landing.giustup.it";
    // location.href = "/home";
    //refresh App.vue
    this.$router.push({name: "Home"});
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Logout.vue